import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { PaypalCopySource } from 'app/model/pipeline/copysource/paypal.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PaypalCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class PaypalCopySourceAdapter extends CopySourceAdapter<PaypalCopySource, Model.PaypalSource> {
    protected override async _toResource(copySource: PaypalCopySource): Promise<Model.PaypalSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(PaypalCopySource).name);
    }

    protected override async _toModel(
        resource: Model.PaypalSource,
        copyActivity: CopyActivity
    ): Promise<PaypalCopySource> {
        return this._toTabularModel(resource, copyActivity, PaypalCopySource.MODEL);
    }
}
